<!--  -->
<template>
  <section>
    <el-dialog ref="customDialog" custom-class="custom-dialog" :before-close="close" v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
      <div v-if="!!title" class="flex al_ce jc_sb dialog-header">
        <div class="width100" :class="[isCenter?'jc_ce flex':'js_fs flex']">
          <span class="size18 marginR8" v-if="!!type"> 
            <i v-if="type == 'info'" class="el-icon-info color189 "></i>
            <i v-if="type == 'error'" class="el-icon-error colorF54 "></i>
            <i v-if="type == 'warning'" class="el-icon-warning colorFE8 "></i>
            <i v-if="type == 'success'" class="el-icon-success color29C "></i></span>
          <label class="size16 pingfang_blod">{{ title }}</label>
        </div>
        <div v-if="showClose" @click="close"><i class="el-icon-close size18 pointer close-icon"></i></div>
      </div>
      <slot name="header"></slot>
      <div :class="contentClass">
        <slot name="content">
      </slot>
      </div>
      <slot name="footer">
        <div slot="footer" v-if="isShowCancelBtn||isShowConfirmBtn" class="dialog-footer" :class="[isCenter?'jc_ce flex':'js_ed flex']">
          <custom-button type="info" v-if="isShowCancelBtn" :loading="cancelLoading" @click="closeFn(false)">{{ cancelBtnTitle }}</custom-button>
          <custom-button v-if="isShowConfirmBtn" type="primary" @click="closeFn(true)" :loading="saveLoading" :disabled="confirmDisabled"
            @keydown.enter.native="closeFn(true)">{{ saveBtnTitle }}</custom-button>
        </div>
      </slot>
    </el-dialog>
  </section>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  name: 'customDialog',
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    type:{
      type:String,
      default:'',
    },
    title: {
      type: String,
      default: ''
    },
    saveBtnTitle: {
      type: String,
      default: '确定'
    },

    cancelBtnTitle: {
      type: String,
      default: '取消'
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    isCenter: {
      type: Boolean,
      default: false,
    },
    isCancel: {
      type: Boolean,
      default: false,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
    cancelLoading: {
      type: Boolean,
      default: false,
    },
    className:{
      type:String,
      default:'custom-dialog'
    },
    contentClass:{
      type:String,
      default:'dialog-content'
    },
    isShowConfirmBtn:{
       type:Boolean,
        default:true,
    },
    isShowCancelBtn:{
       type:Boolean,
        default:true,
    },
    confirmDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    //这里存放数据
    return {

    };
  },
  //监听属性 类似于data概念
  computed: {

  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    close() {
      if (this.isCancel) {
        this.$emit('cancel');
      } else {
        this.$emit('close')
      }
    },
    closeFn(sign) {
      let name = sign ? 'save' : 'close';
      this.$emit(name)
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss'>
//@import url(); 引入公共css类

.custom-dialog {
  .color29C {
    color: #29C01B;
  }

  .colorFE8 {
    color: #FE8F1F
  }

  .colorF54 {
    color: #F54A45
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0 !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }

  .el-dialog__footer {
    padding: 0;
    box-sizing: border-box;
  }

  .dialog-header {
    height: 48px;
    box-sizing: border-box;
    padding: 0 20px 0 24px;
    color: #1F2329;
    border-bottom: 1px solid #EBEAEE;
    .close-icon {
      color: #9AA0A8;
    }
  }
  .dialog-content{
    padding: 20px 24px;
    overflow: auto;
    max-height: 680px;
  }
  .dialog-footer{
    padding:12px 24px 16px 24px;
  }
  .size18{
    font-size: 18px;
  }
  .marginR8{
    margin-right: 8px;
  }
  .color189{
    color: #1890ff;
  }
  .colorF54{
    color:#F54A45;
  }
  .colorFE8{
    color:#FE8F1F;
  }
  .color29C{
    color:#29C01B;
  }
  .pointer{
    cursor: pointer;
  }
  .flex{
    display: flex;
  }
  .jc_ce{
    justify-content: center;
  }
  .js_ed{
    justify-content: flex-end;
  }
  .js_fs{
    justify-content: flex-start;
  }
  .al_ce{
    align-items: center;
  }
  .jc_sb{
    justify-content: space-between;
  }
}
</style>
